/* eslint-disable no-undef */
/* eslint-disable react/display-name */
import React, { useState, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { ReportUsageContext } from 'src/pages/reportUsage';
import { initialButtonState } from 'src/pages/reportUsage/footer/InitialButtonState';
import { unlockOrderFunc } from 'src/pages/reportUsage/redux/saga/dataServices';
import UnsavedChanges from 'src/pages/scheduleSurgery/components/surgery/notifications/UnsavedChanges';
import {
    OrdersListViewContainer,
    SetContainer,
    Title,
    FlexColumnContainer
} from 'src/pages/home/component/orders/ordersListView/OrdersListView.styled';
import {
    BoldTruncatedItem,
    CaseRefText,
    HeaderData,
    HeaderLeftBordered,
    DemiText,
    BodyContainer,
    SmallHeaderText,
    UNiDContainer,
    AccountNameNumberText,
    RegularTruncateText,
    RegularText,
    SplitButtonContainer,
} from 'src/common/refactoredComponents/dataTable/DataTable.styled';
import {
    LabelFont,
    OrderListDataContainer,
} from 'src/styles/CommonStyles.styled';
import Datatable from 'src/common/refactoredComponents/dataTable/DataTable';
import {
    setOrdersListFilter,
    getRefinedOrderListData,
    setOrderSummaryModalState,
    setReportProcedureModalState,
    setSendReportModalState,
    setOrderStatus,
    showDeleteOrderAction,
    actionApplyFilterType,
    setOrderSummaryTabAction,
    showHideSearchModalAction,
    showHideRequestInvoice,
    toggleSearchResult,
    showHideProcedureModalAction,
    setCtaData,
    triggerEventNotification,
    SET_NOTIFICATION_FAILURE_RESPONSE,
} from 'src/pages/orders/redux/actions';
import {
    getDisplayDate,
    getNumberOfDaysBetweenTwoDates,
} from 'src/utils/dateUtils';
import {
    getDefaultCTAId,
    orderStatusColorCode,
    fromOrderTypeToLabel,
    getReportUsageResourceType,
    isIpad,
    resumeScrolling,
    hideScrolling,
    getRoutePathWithParams,
    getRefTotalHeight,
    getOrderLockedAction,
    isUsageSubmissionProcessing,
    checkTemplateReviewUserRoleChanges,
    getUserDetails,
    checkPriceOverRideOrderAmount,
    detectDeviceInfo,
    convertDateToISOString,
    fromOrderTypeToModuleName,
    logErrorToConsole,
} from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import UnidHubOrderDeletePopup from 'src/pages/orders/components/unidHubOrderDeletePopup/UnidHubOrderDeletePopup';
import { useHistory } from 'react-router';
import { getCTAWCMSLink } from 'src/constants/wcmsRedirectionLinks';
import {
    CTA_IDS,
    isCopyCtaId,
    isTrueCopyCtaId,
    ENABLED,
    OrderStatuses,
    SURGERY_TEMPLATE_MANDATORY_FIELDS,
    VISIBLE,
    EQUITY,
    REPORT_PROCEDURE_DATA,
    NO_USAGE_REPORT,
    ORDERS
} from 'src/constants/appConstants';
import UnidItem from 'src/common/components/unidItem/UnidItem';
import RequestInvoice from 'src/pages/orders/components/reportsAndInvoice/requestInvoice/RequestInvoice';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import CreateTemplate from 'src/common/refactoredComponents/createTemplate';
import TorqueQRCode from 'src/common/refactoredComponents/torqueQRCode';
import AlertIcons from 'src/assets/images/AlertIcons.svg';
import { sizes } from 'src/styles/Media.styled';
import {
    storeSurgeryDetails,
    cancelUsageOrderRequest,
    setShowNoUsageToReportOrCancelPopup,
    resetProgressBarStatus,
    resetReportUsageStates,
    setShippingDetails,
    resetDiscrepancyUsageDetails,
    getValidateAccountDetails,
} from 'src/pages/reportUsage/redux/action/actionCreators';

import { setActiveNavLink } from 'src/pages/home/redux/actions';
import AlertIconYellow from 'src/assets/images/AlertIconYellow.svg';
import { ConstantOrderTypeFilter, OrderSummaryTabs } from 'src/constants/orderListConstants.js';
import {
    checkIfOrderLockedFunc,
    getOrderStatusDetailsFunc,
} from 'src/pages/reportUsage/redux/saga/dataServices';
import { PROCESS } from 'src/constants/appConstants';
import CancelAlertPopup from 'src/pages/reportUsage/common/cancelAlertPopup';
import PriceTag from 'src/common/components/priceTags/priceTags';
import CreateEquityTemplate from 'src/pages/equity/components/common/createTemplate/index.jsx';
import {
    getEquityDetails,
    resetEquityDetails,
} from 'src/pages/equity/redux/actions';
import {
    resetConsignmentAddDetails,
} from 'src/pages/consignmentAdd/redux/actions';

import { fetchUsageDetailsRequest } from 'src/pages/reportUsage/redux/action/actionCreators';
import AlertCircle from 'src/assets/images/AlertCircle.svg';
import {
    getSurgeryDetails,
    resetBomData,
    resetCreateOrUpdateSurgery,
    resetDropdown,
    resetShipToAddress,
    resetSurgeryDetails,
    resetSurgeryDetailsReducer,
    resetValidateAccountDetails,
    reSetProgressBarStatus as resetProgressBarStatusSurgery,
} from 'src/pages/scheduleSurgery/redux/actions';
import {
    getCheckOrderActionEligibility,
    getCheckOrderActionEligibilityReset
} from 'src/pages/orders/redux/actions';
import { RESET_CANCEL_USAGE_STATES } from 'src/pages/reportUsage/redux/action/types';
import TissueIcon from 'src/assets/images/TissueIcon.svg';
import NonTissueIcon from 'src/assets/images/NonTissueItemIcon.svg';
import NonTissueIconsmall from 'src/assets/images/NonTissueIconsmall.svg';
import TissueIconsmall from 'src/assets/images/TissueIconsmall.svg';
import ReplenishIcon from 'src/assets/images/ReplenishIcon.svg';
import { OrderTypeSpanContianer } from 'src/common/components/priceTags/priceTags.styled';
import MessageTemplate from 'src/pages/equity/components/common/notifications/MessageTemplate';
import { COUNTRY_CODE_JAPN, GETEQUITYDETAILSDATA } from 'src/constants/productConstants';
import { getConfigurations, resetNotes, setPediatricCheck } from 'src/common/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { PINK_HIGHLIGHT_COLOR, PARKED_LABEL } from 'src/styles/fonts/MCFontConstants';
import { setQrGenerated } from 'src/common/redux/actions';
const OrdersListTableView = (props) => {
    const {
        disablePaginator,
        openOrderSummaryHandler,
        scrollHeight,
        isOrderHistory = false,
        isSearchOrderList,
        searchOrderList,
        totalNumberOfRecords,
        searchPageChangeHandler,
        searchFirst,
        searchSortOrder,
        searchSortParam,
        searchSortHandler,
        scrollHeightNoQuickFilter,
        scrollNoAppliedFilters,
        scrollHeightWithFilters,
        retriggerEventNotification,
        setRetriggerEventNotification,
        setNotificationDetails,
        notificationDetails
    } = props;
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation();
    const [sortControl, setSortControl] = useState(false);
    const [pageControl, setPageControl] = useState(false);
    const location = useLocation();
    // Use setFooterButtonStatuses from ReportUsageContext if available, otherwise fallback to a no-op
    const contextValue = useContext(ReportUsageContext);
    const setFooterButtonStatuses = contextValue?.setFooterButtonStatuses || (() => { });

    const [page, setPage] = useState(0);
    const [first, setFirst] = useState(0);
    const [sortParam, setSortParam] = useState('submitDate');
    const [sortOrder, setSortOrder] = useState(1);
    const [sortedOrder, setSortedOrder] = useState({
        mCaseRefSort: false,
        physicianDisplaySort: false,
        accountSort: false,
        orderStatusDescription: false,
    });
    const [formattedOrders, setFormattedOrders] = useState([]);
    const [deleteNotAllowedPopupOpen, setDeleteNotAllowedPopupOpen] =
        useState(false);
    const [tableRowData, setTableRowData] = useState(null);
    const [showViewTemplate, handleViewTemplate] = useState(false);
    const toggleViewTemplate = () => {
        handleViewTemplate(!showViewTemplate);
        dispatch(resetDropdown());
    };
    const [dialogZindex, setDialogZindex] = useState(10000);
    const [tempValidationData, setTempValidationData] = useState({});
    const validateAccount = useSelector(
        (state) => state.surgeryvalidateAccountReducer.validateAccount
    );
    const [isEdit, setIsEdit] = useState(false);
    const [isFutureDatedOrder, setIsFutureDatedOrder] = useState(false);
    const [showTorqueQR, setShowTorqueQR] = useState(false);
    const [torqueQRParams, setTorqueQRParams] = useState(null);
    const { isAllowed, statusCode } = useSelector((state) => state.checkOrderActionEligibilityReducer);
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));
    const {qrCodeData ,qrCodeLoading, qrCodeError, qrGenerated} = useSelector((state) => state.qrCodeReducer);
    useEffectWithErrorLogging(() => {

        if (
            validateAccount.data &&
            validateAccount?.statusCode?.length > 0 &&
            !validateAccount.data.hasOwnProperty('blockMessage') &&
            tempValidationData.hasOwnProperty('primary') &&
            tempValidationData.hasOwnProperty('row')
        ) {
            handleCTAAction(tempValidationData.primary, tempValidationData.row);
            setTempValidationData({});
        }
    }, [validateAccount, tempValidationData]);
    const {
        orderSummaryModal,
        requestInvoiceState,
        isRequestInvoiceSearchListPage,
        isRequestInvoiceOrderListPage,
        myCaseRef
    } = useSelector((state) => state.orderSummaryReducer);


    const {
        procedureTypeConsignmentAdd,
        procedureVisibilityKE,
        deliveryCheckEdit,
        deliveryCheckNoUsageToReport
    } = useSelector((state) => state.loginReducer);

    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );

    const PAGE_LIMIT = 50;

    const { orderList, loading } = useSelector(
        (state) => state.ordersListReducer
    );

    const appliedUserFilters = useSelector(
        (state) => state.appliedOrdersFilterReducer
    );
    const { filter } = useSelector((state) => state.appliedOrdersFilterReducer);

    const { sortOrder: orderListSortOrder, sortParam: orderListSortParams } =
        appliedUserFilters || {};

    const { appliedCategory, isFilterType,notificationStatus,isFromOrderSummary } = useSelector(
        (state) => state.orderFilterReducer
    );
    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    const loggedInUserDetails = useSelector(
        (state) => state.loginReducer.hybrisUserDetails
    );
    const employeeRole = getUserDetails();
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);
    const [innerHeight, setInnerHiehgt] = useState(window.innerHeight);

    const initialOrderLockState = {
        show: false,
        myCaseRef: null,
        modifiedBy: null,
        action: null,
    };
    const [usageProcessingPopup, setUsageProcessingPopup] = useState(null);
    const [showOrderLockedPopup, setShowOrderLockedPopup] = useState(
        initialOrderLockState
    );
    const closeOrderActionPopup = async () => {
        if (usageProcessingPopup) {
            const response = await unlockOrderFunc({
                action: usageProcessingPopup.action,
                myCaseRefId: usageProcessingPopup.myCaseRef,
            });
            if (response === 'error') return false;
        }
        setUsageProcessingPopup(null);
        setShowOrderLockedPopup(initialOrderLockState);
        return true;
    };

    const iPad = isIpad();
    window.onresize = () => {
        setInnerWidth(window.innerWidth);
        setInnerHiehgt(window.innerHeight);
    };
    const [blockedAccountMessagePopUp, setBlockedAccountMessagePopUp] =
        useState(false);
    useEffectWithErrorLogging(() => {
        if (
            isFilterType !== 'delete' &&
            isFilterType !== 'pagination' &&
            isFilterType !== 'pageSort'
        ) {
            setPage(0);
            setFirst(0);
        }
    }, [isFilterType]);

    const ctaDetails = useSelector((state) => state.ctaDataReducer);
    const [surgeryEdit, setSurgeryEdit] = useState(false);
    useEffectWithErrorLogging(() => {
        if (!isAllowed && statusCode === '13202') {
            setSurgeryEdit(false);
        }
        if (
            validateAccount.data.blockMessage ||
            validateAccount.statusCode === '' ||
            !surgeryEdit
        ) {
            return;
        }
        editSurgery(surgeryEdit.myCaseRef);
    }, [validateAccount, surgeryEdit, isAllowed]);

    const formatOrdersList = (orderList) => {
        return (orderList || []).map((order) => {
            const callToActionList = (Array.isArray(order?.callToActionList)
                ? order.callToActionList
                : []
            ).filter((cta) => {
                const isCopyCta = isCopyCtaId(cta?.ctaId);
                const isUS = countryISOCode === 'US';
                return !(
                    isOrderHistory &&
                    isCopyCta &&
                    ((order?.currentOrderType === 'ZOR' && !isUS) ||
                        (order?.currentOrderType === 'KB' && isUS))
                );
            });

            return {
                ...order,
                callToActionList,
                accountNumber: parseInt(order.accountNumber, 10),
                surgeryDate: order.surgeryDate
                    ? new Date(order.surgeryDate).toDateString()
                    : null,
                submitDate: new Date(order.submitDate).toDateString(),
                hrefId: order.hrefId ? order.hrefId : '',
                patientName: order.patientName ? order.patientName : '',
            };
        });
    };
 useEffectWithErrorLogging(() => {
        if (notificationStatus?.length>0) {
            setRetriggerEventNotification(false);
             setNotificationDetails({});
              dispatch(
                setOrdersListFilter({
                    ...appliedUserFilters,
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    pageNo: page,
                    pageLimit: PAGE_LIMIT,
                })
            );
            dispatch(
                getRefinedOrderListData({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        startDate: convertDateToISOString(
                            new Date(props.firstOrderStartDate),
                            'start'
                        ),
                    },
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    pageNo: page,
                    pageLimit: PAGE_LIMIT,
                      isFromOrderHistory:isOrderHistory,
                })
            );
         if(isFromOrderSummary)
         {
                  dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: isFromOrderSummary,
                        orderSummaryModal: true,
                        is
                    })
                );
            }
         

    let data ={statusCode:''};
    data.myCaseRef='';
     dispatch({ type: SET_NOTIFICATION_FAILURE_RESPONSE, data: data, });
  
        }
    }, [notificationStatus]);
    useEffectWithErrorLogging(() => {
        const data = formatOrdersList(orderList);
        setFormattedOrders(data);
    }, [orderList]);

    useEffectWithErrorLogging(() => {
        if (isSearchOrderList) {
            setFormattedOrders(formatOrdersList(searchOrderList));
        }
    }, [searchOrderList]);

    useEffectWithErrorLogging(() => {
        if (pageControl) {
            dispatch(actionApplyFilterType('pagination'));
            dispatch(
                setOrdersListFilter({
                    ...appliedUserFilters,
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    pageNo: page,
                    pageLimit: PAGE_LIMIT,
                })
            );
            dispatch(
                getRefinedOrderListData({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        startDate: convertDateToISOString(
                            new Date(props.firstOrderStartDate),
                            'start'
                        ),
                    },
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    pageNo: page,
                    pageLimit: PAGE_LIMIT,
                      isFromOrderHistory:isOrderHistory,
                })
            );
            setPageControl(false);
        }
    }, [page]);

    useEffectWithErrorLogging(() => {
        setSortParam(orderListSortParams);
        setSortOrder(orderListSortOrder === 'ASC' ? 1 : -1);
    }, [orderListSortOrder, orderListSortParams]);

    useEffectWithErrorLogging(() => {
        if (sortParam && sortControl) {
            dispatch(actionApplyFilterType('pageSort'));
            dispatch(
                setOrdersListFilter({
                    ...appliedUserFilters,
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    sortParam: sortParam,
                    sortOrder: sortOrder === 1 ? 'ASC' : 'DESC',
                })
            );
            dispatch(
                getRefinedOrderListData({
                    ...appliedUserFilters,
                    filter: {
                        ...filter,
                        startDate: convertDateToISOString(
                            new Date(props.firstOrderStartDate),
                            'start'
                        ),
                    },
                    startDate: convertDateToISOString(
                        new Date(props.firstOrderStartDate),
                        'start'
                    ),
                    sortParam: sortParam,
                    sortOrder: sortOrder === 1 ? 'ASC' : 'DESC',
                      isFromOrderHistory:isOrderHistory,
                })
            );
            setSortControl(false);
        }
    }, [sortParam, sortOrder]);

    const getWCMSRedirectionLink = (order, cta) => {
        return getCTAWCMSLink(order, cta);
    };

    const editSurgery = (myCaseRef) => {
        if (!isAllowed && deliveryCheckEdit === VISIBLE) { return; }
        dispatch(setPediatricCheck(''));
        dispatch(resetNotes());
        dispatch(resetCreateOrUpdateSurgery());
        dispatch(resetProgressBarStatusSurgery());
        dispatch(resetSurgeryDetails());
        dispatch(resetSurgeryDetailsReducer());
        dispatch(resetShipToAddress());
        dispatch(resetBomData());
        dispatch(setActiveNavLink({ calendar: false, orders: true }));
        history.push({
            ...getRoutePathWithParams(`/modifySurgery/${myCaseRef}`),
            state: {
                from: location?.pathname ? location.pathname : null,
                navOrigin: 'orders',
            },
        });
    };

    const editEquity = (myCaseRef, accountName) => {
        dispatch(setActiveNavLink({ calendar: false, orders: true }));
        history.push({
            ...getRoutePathWithParams(`/modifyEquity/${myCaseRef}`),
            state: {
                from: location?.pathname ? location.pathname : null,
                account: accountName,
            },
        });
    };
    //Transfer Surgery
    const transferSurgery = (myCaseRef) => {
        dispatch(setActiveNavLink({ calendar: true, orders: false }));
        history.push({
            ...getRoutePathWithParams(`/transferSurgery/${myCaseRef}`),
            state: { from: location?.pathname ? location.pathname : null },
        });
    };

    const navigateToReportUsageFlow = (rowData, ctaID) => {
        dispatch(setPediatricCheck(''));
        dispatch(setShippingDetails([]));
        const reportUsageObj = {
            resourceType: getReportUsageResourceType(
                rowData.orderStatusDescription,
                ctaID
            ),
            myCaseRef: rowData.myCaseRef,
            fromOrdersList: true,
            isFromOrderDetailsModal: false,
        };
        dispatch(storeSurgeryDetails(reportUsageObj));
        localStorage.setItem('myCaseRefUsage', JSON.stringify(reportUsageObj));
        history.push({
            ...getRoutePathWithParams(`/reportUsage/${rowData.myCaseRef}`),
            state: {
                from: '/orders',
                // from: location?.pathname ? location.pathname : null,
                orderStatus: rowData.orderStatusDescription,
                myCaserefId: rowData.myCaseRef,
                isfromModal: false,
            },
        });
    };

    const handleEventRetrigger =(data,flag=false)=>
    {
          dispatch(triggerEventNotification({myCaseRef:data?.myCaseRef,
            orderType:data?.orderType
        },flag));
    };

    useEffectWithErrorLogging(() => {
        if (
            validateAccount.data.blockMessage &&
            blockedAccountMessagePopUp === false
        ) {
            setBlockedAccountMessagePopUp(true);
        }
    }, [validateAccount, getValidateAccountDetails]);
    useEffectWithErrorLogging(() => {
        dispatch(resetValidateAccountDetails());
    }, []);

    const handleCTAAction = async (cta, rowData) => {
        // Copy fires in order history for any copy CTA, and in the normal orders flow only
        // for the true copy CTAs (CTA_003/CTA3) so the Torque QR CTA (CTA_026) is preserved.
        const isCopyCTA =
            isCopyCtaId(cta?.ctaId) &&
            (isOrderHistory || isTrueCopyCtaId(cta?.ctaId));
        if (isCopyCTA) {
            const isEquityOrder = rowData?.currentOrderType === 'ZOR';
            const isConsignmentAddOrder = rowData?.currentOrderType === 'KB';
            if (isEquityOrder) {
                dispatch(resetEquityDetails());
                // Reserve a brand new equity reference (creation call) so the
                // copied order is created as a distinct new order.
                dispatch(getEquityDetails(GETEQUITYDETAILSDATA));
                dispatch(
                    setActiveNavLink(
                        isOrderHistory
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : { calendar: false, orders: true, inventory: false, more: false }
                    )
                );
                history.push({
                    ...getRoutePathWithParams(
                        `/modifyEquity/${rowData?.myCaseRef}`
                    ),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        account: rowData?.accountName,
                        sourceMyCaseRef: rowData?.myCaseRef,
                        sourceOrderType: rowData?.currentOrderType,
                        isFromOrderHistory: isOrderHistory,
                        isCopyFromSummary: !isOrderHistory,
                    },
                });
                return;
            }
            if (isConsignmentAddOrder) {
                dispatch(resetConsignmentAddDetails());
                    dispatch(
                    setActiveNavLink(
                        isOrderHistory
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : { calendar: false, orders: true, inventory: false, more: false }
                    )
                );
                history.push({
                    ...getRoutePathWithParams(
                        '/consignmentAdd'
                    ),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        account: rowData?.accountName,
                        sourceMyCaseRef: rowData?.myCaseRef,
                        sourceOrderType: rowData?.currentOrderType,
                        isFromOrderHistory: isOrderHistory,
                        isCopyFromSummary: !isOrderHistory,
                    },
                });
                return;
            }
            // ZLC / ZLB "Copy" -> /scheduleSurgery
            if (
                !isEquityOrder &&
                !isConsignmentAddOrder
            ) {
                dispatch(resetSurgeryDetails());
                // A surgery order copied from the orders listing must keep the
                // "orders" nav link active (like equity/consignment); only fall
                // back to "calendar" when copied from a non-orders origin.
                const isFromOrdersPage = (location?.pathname || '').includes('/orders');
                dispatch(
                    setActiveNavLink(
                        isOrderHistory
                            ? { calendar: false, orders: false, inventory: false, more: true }
                            : isFromOrdersPage
                            ? { calendar: false, orders: true, inventory: false, more: false }
                            : { calendar: true, orders: false, inventory: false, more: false }
                    )
                );
                history.push({
                    ...getRoutePathWithParams('/scheduleSurgery'),
                    state: {
                        from: location?.pathname ? location.pathname : null,
                        sourceMyCaseRef: rowData?.myCaseRef,
                        sourceOrderType: rowData?.currentOrderType,
                        isMastOrder: rowData?.isMastOrder,
                        isFromOrderHistory: isOrderHistory,
                        isCopyFromSummary: !isOrderHistory,
                        account: rowData?.accountName,
                    },
                });
                return;
            }
            dispatch(
                setActiveNavLink({
                    calendar: !isEquityOrder && !isConsignmentAddOrder,
                    orders: isEquityOrder,
                    inventory: isConsignmentAddOrder,
                })
            );
            history.push({
                ...getRoutePathWithParams(
                    isEquityOrder
                        ? '/equity'
                        : isConsignmentAddOrder
                        ? '/consignmentAdd'
                        : '/scheduleSurgery'
                ),
                state: {
                    from: location?.pathname ? location.pathname : null,
                    sourceMyCaseRef: rowData?.myCaseRef,
                    sourceOrderType: rowData?.currentOrderType,
                    isFromOrderHistory: !!isOrderHistory,
                },
            });
            return;
        }
        
        setTableRowData(rowData);
        dispatch(setPediatricCheck(''));
        dispatch(resetNotes());
        setFooterButtonStatuses(initialButtonState());
        let orderLockedData, orderStatus;
        const orderLockAction = getOrderLockedAction(
            cta.ctaId,
            rowData?.currentOrderType,
            rowData?.orderStatusDescription
        );
        dispatch({ type: RESET_CANCEL_USAGE_STATES });
        cta.ctaId === 'CTA_022' && dispatch(
            getConfigurations(
                { resourceType: 'visibility', module: EQUITY },
                REPORT_PROCEDURE_DATA
            )
        );
        cta.ctaId === 'CTA_007' && dispatch(
            getConfigurations(
                { resourceType: 'visibility', module: NO_USAGE_REPORT },
                NO_USAGE_REPORT
            )
        );
        if (
            orderLockAction &&
            ((cta.ctaId === CTA_IDS.editOrder &&
                rowData?.currentOrderType === 'ZLC' &&
                process.env.ENABLE_SCHEDULE_SURGERY) ||
                ((cta.ctaId === CTA_IDS.reportUsage ||
                    (rowData?.currentOrderType === 'ZLB' &&
                        (cta.ctaId === CTA_IDS.editOrder ||
                            cta.ctaId === CTA_IDS.reportPayment))) &&
                    process.env.ENABLE_REPORT_USAGE) ||
                (process.env.ENABLE_NO_USAGE_TO_REPORT &&
                    loggedInUserDetails &&
                    (cta.ctaId === CTA_IDS.noUsageToReport ||
                        cta.ctaId === CTA_IDS.unidPostponed)))
        ) {
            orderLockedData = await checkIfOrderLockedFunc({
                action: orderLockAction,
                myCaseRefId: rowData.myCaseRef,
                orderType:
                    orderLockAction === 'ReportUsage'
                        ? 'ZLB'
                        : rowData?.currentOrderType,
            });
            if (cta.ctaId === CTA_IDS.reportUsage) {
                orderStatus = await getOrderStatusDetailsFunc(
                    rowData.myCaseRef
                );
            }
            if (
                process.env.ENABLE_NO_USAGE_TO_REPORT &&
                loggedInUserDetails & (cta.ctaId === CTA_IDS.noUsageToReport)
            ) {
                dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: rowData.myCaseRef,
                        orderSummaryModal: false,
                        isFromOrderHistory: isOrderHistory,
                    })
                );
            }
        }

        if (
            cta.ctaId === CTA_IDS.editOrder &&
            rowData?.currentOrderType === 'ZLC' &&
            process.env.ENABLE_SCHEDULE_SURGERY
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                // editSurgery(rowData.myCaseRef);
                if (
                    ctaDetails.orderStatus ===
                    t('orders.orderQuickFilters.usageOrders.inProcess')
                ) {
                    setSurgeryEdit(rowData);
                } else {
                    editSurgery(rowData.myCaseRef);
                }
            }
        } else if (
            cta.ctaId === CTA_IDS.transfer &&
            (rowData?.currentOrderType === 'ZLC' ||
                rowData.currentOrderType === 'ZLB') &&
            process.env.ENABLE_SCHEDULE_SURGERY
        ) {
            transferSurgery(rowData.myCaseRef);
        } else if (
            (cta.ctaId === CTA_IDS.reportUsage ||
                (rowData?.currentOrderType === 'ZLB' &&
                    (cta.ctaId === CTA_IDS.editOrder ||
                        cta.ctaId === CTA_IDS.reportPayment))) &&
            process.env.ENABLE_REPORT_USAGE
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData.myCaseRef,
                    modifiedBy: orderLockedData?.user
                        ? orderLockedData?.user
                        : orderStatus?.userId,
                    action: orderLockAction,
                });
            } else if (isUsageSubmissionProcessing(orderStatus)) {
                setUsageProcessingPopup({
                    myCaseRef: rowData.myCaseRef,
                    userId: orderStatus.userId,
                    action: orderLockAction,
                });
            } else {
                dispatch(resetProgressBarStatus());
                dispatch(resetReportUsageStates());
                navigateToReportUsageFlow(rowData, cta.ctaId);
            }
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            cta.ctaId === CTA_IDS.noUsageToReport
        ) {

            //check for delivery eligibility
            if (deliveryCheckNoUsageToReport === VISIBLE) {
                const deliveryCheckPayload = {
                    orderType: 'ZLC',
                    action: 'cancel',
                    myCaseRef: rowData.myCaseRef
                };
                dispatch(
                    getCheckOrderActionEligibility(
                        deliveryCheckPayload
                    )
                );
            }

            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                const diffBetweenDates = getNumberOfDaysBetweenTwoDates(
                    new Date(),
                    rowData.surgeryDate
                );
                if (
                    diffBetweenDates <= 0 ||
                    rowData.createdBy !== loggedInUserDetails.uid
                ) {
                    dispatch(
                        setShowNoUsageToReportOrCancelPopup({
                            showNoUsagePopup:
                                rowData.createdBy === loggedInUserDetails.uid,
                            showCancelPopup:
                                rowData.createdBy !== loggedInUserDetails.uid,
                            surgeryData: rowData,
                            viewProcedureScreen: false,
                            showUnidPostponePopup: false,
                            showCaseCancelOrPostpone: false,
                            isFromOrderDetailsModal: false,
                        })
                    );
                } else if (
                    diffBetweenDates >= 0 &&
                    rowData.createdBy === loggedInUserDetails.uid
                ) {
                    //SIM-1137 changes
                    if (deliveryCheckEdit === VISIBLE) {
                        setIsFutureDatedOrder(true);
                        setTableRowData(rowData);
                    }
                    else {
                        setTableRowData(rowData);
                        dispatch(
                            cancelUsageOrderRequest(
                                { myCaseRef: rowData.myCaseRef },
                                true,
                                false
                            )
                        );
                    }
                }
            }
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            cta.ctaId === CTA_IDS.caseCancelOrPostpone
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                dispatch(
                    getSurgeryDetails(rowData.myCaseRef, true, false, true)
                );
                dispatch(
                    setShowNoUsageToReportOrCancelPopup({
                        showNoUsagePopup: false,
                        showCancelPopup: false,
                        surgeryData: rowData,
                        viewProcedureScreen: false,
                        showCaseCancelOrPostpone: true,
                        isFromOrderDetailsModal: false,
                    })
                );
            }
        } else if (
            process.env.ENABLE_NO_USAGE_TO_REPORT &&
            loggedInUserDetails &&
            cta.ctaId === CTA_IDS.unidPostponed
        ) {
            if (orderLockedData?.isOrderLocked) {
                setShowOrderLockedPopup({
                    show: true,
                    myCaseRef: orderLockedData?.myCaseRef
                        ? orderLockedData?.myCaseRef
                        : rowData.myCaseRef,
                    modifiedBy: orderLockedData?.user,
                    action: orderLockAction,
                });
            } else {
                // const diffBetweenDates = getNumberOfDaysBetweenTwoDates(
                //     new Date(),
                //     rowData.surgeryDate
                // );
                // if (
                //     diffBetweenDates <= 0 ||
                //     rowData.createdBy !== loggedInUserDetails.uid
                // ) {
                dispatch(
                    getSurgeryDetails(rowData.myCaseRef, true, false, true)
                );
                dispatch(
                    setShowNoUsageToReportOrCancelPopup({
                        showNoUsagePopup: false,
                        showCancelPopup: false,
                        surgeryData: rowData,
                        viewProcedureScreen: false,
                        showUnidPostponePopup: true,
                        showCaseCancelOrPostpone: false,
                        isFromOrderDetailsModal: false,
                    })
                );
                // } else if (
                //     diffBetweenDates > 0 &&
                //     rowData.createdBy === loggedInUserDetails.uid
                // ) {
                //     dispatch(
                //         cancelUsageOrderRequest(
                //             { myCaseRef: rowData.myCaseRef },
                //             true
                //         )
                //     );
                // }
            }
        } else if (
            cta.ctaId === CTA_IDS.delete &&
            (rowData?.currentOrderType === 'ZLC' ||
                rowData?.currentOrderType === 'ZLB' ||
                rowData?.currentOrderType === 'ZOR')
        ) {
            rowData?.unidCaseId || rowData?.unidCaseNo
                ? setDeleteNotAllowedPopupOpen(true)
                : dispatch(
                    showDeleteOrderAction({
                        isDeletePopup: true,
                        deleteMyCaseRef: rowData.myCaseRef,
                        isOrderDetailsModal: false,
                        isOtherUser:
                            loggedInUserDetails?.uid &&
                                loggedInUserDetails.uid !== rowData.createdBy
                                ? true
                                : false,
                    })
                );
        } else if (
            cta.ctaId === CTA_IDS.viewOrder &&
            (rowData?.currentOrderType === 'ZLC' ||
                rowData?.currentOrderType === 'ZLB' ||
                rowData?.currentOrderType === 'ZOR' ||
                rowData?.currentOrderType === 'KE' ||
                rowData?.currentOrderType === 'ZKA' ||
                rowData?.currentOrderType === 'KB' ||
                rowData?.currentOrderType === 'CR' ||
                rowData?.currentOrderType === 'ZWR' ||
                rowData?.currentOrderType === 'ZFKB' ||
                rowData?.currentOrderType === 'ZTR' ||
                rowData?.currentOrderType === 'DR' ||
                rowData?.currentOrderType === 'ZCC' ||
                rowData?.currentOrderType === 'ZLBR' ||
                rowData?.currentOrderType === 'ZCC1' ||
                rowData?.currentOrderType === 'G2' ||
                rowData?.currentOrderType === 'L2')
        ) {
             onRowClick(rowData);
        
        }
      else if (
            cta.ctaId === CTA_IDS.retriggerNotification )
            {
               setRetriggerEventNotification && setRetriggerEventNotification(true);
               setNotificationDetails && setNotificationDetails({ orderType:rowData?.currentOrderType, myCaseRef:rowData?.myCaseRef});
            }
        else if (
            (cta.ctaId === CTA_IDS.billingSummary ||
                cta.ctaId === CTA_IDS.viewAdjustments) &&
            (rowData?.currentOrderType === 'ZLC' ||
                rowData?.currentOrderType === 'ZLB' ||
                rowData?.currentOrderType === 'ZOR')
        ) {
            dispatch(
                setOrderSummaryTabAction({
                    selectedTabId: OrderSummaryTabs()[4].id,
                }) //Setting Billing Summary Id to OrderSummary redux state selectedTabId.
            );
            if (isSearchOrderList) {
                dispatch(
                    showHideSearchModalAction({
                        showSearchModal: false,
                    })
                );
            }
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: rowData.myCaseRef,
                    orderSummaryModal: !orderSummaryModal,
                    isFromOrderHistory: isOrderHistory,
                })
            );
        } else if (
            cta.ctaId === CTA_IDS.viewUsageReports &&
            (rowData?.currentOrderType === 'ZLC' ||
                rowData?.currentOrderType === 'ZLB')
        ) {
            dispatch(resetDiscrepancyUsageDetails());
            dispatch(
                setOrderStatus({ orderStatus: rowData?.orderStatusDescription })
            );
            const sendReportModalObject = {
                showModal: true,
                myCaseRefId: rowData?.myCaseRef,
            };
            !isSearchOrderList
                ? (sendReportModalObject['isUsageReportOrderListPage'] = true)
                : (sendReportModalObject['isUsageReportSearchListPage'] = true);
            dispatch(setSendReportModalState(sendReportModalObject));
            if (
                rowData.orderStatusDescription ===
                OrderStatuses().paymentInformationNeeded ||
                rowData.orderStatusDescription === OrderStatuses().billingIssues
            ) {
                dispatch(
                    fetchUsageDetailsRequest({
                        resourceType: 'reportPayment',
                        myCaseRef: rowData.myCaseRef,
                        isDiscrepencyCheck: true,
                    })
                );
            }
            if (isSearchOrderList) {
                dispatch(
                    showHideSearchModalAction({
                        showSearchModal: false,
                    })
                );
            }
        } else if (
            cta.ctaId === CTA_IDS.requestInvoice &&
            (rowData?.currentOrderType === 'ZLC' ||
                rowData?.currentOrderType === 'ZLB' ||
                rowData?.currentOrderType === 'ZOR' ||
                rowData?.currentOrderType === 'KE' ||
                rowData?.currentOrderType === 'KB')
        ) {
            const requestInvoiceProp = {
                requestInvoiceState: true,
                myCaseRefId: rowData.myCaseRef,
            };
            !isSearchOrderList
                ? (requestInvoiceProp['isRequestInvoiceOrderListPage'] = true)
                : (requestInvoiceProp['isRequestInvoiceSearchListPage'] = true);
            dispatch(showHideRequestInvoice(requestInvoiceProp));
            if (isSearchOrderList) {
                dispatch(
                    showHideSearchModalAction({
                        showSearchModal: false,
                    })
                );
            }
            // setRequestInvoice((prev) => !prev);
            // setCtaMyCase(rowData.myCaseRef);
        } else if (
            (cta.ctaId === CTA_IDS.createTemplate || cta.ctaId === 'CTA2') &&
            (rowData?.currentOrderType === 'ZLC' ||
                rowData?.currentOrderType === 'ZLB' ||
                rowData?.currentOrderType === 'ZOR')
        ) {
            if (isOrderHistory) {
                dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: rowData.myCaseRef,
                        isFromOrderHistory: true,
                        orderSummaryModal: false,
                    })
                );
            }
            toggleViewTemplate();
            setTableRowData(rowData);
        } else if (
            cta.ctaId === CTA_IDS.editOrder &&
            rowData?.currentOrderType === 'ZOR'
        ) {
            editEquity(rowData?.myCaseRef, rowData?.accountName);
        } else if (
            cta.ctaId === CTA_IDS.procedureData &&
            rowData?.currentOrderType === 'ZOR'
        ) {
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: rowData.myCaseRef,
                    // resourceType: 'BILLING_SUMMARY',
                    orderSummaryModal: false,
                    isFromOrderHistory: isOrderHistory,
                })
            );
            dispatch(
                setSendReportModalState({
                    myCaseRefId: rowData.myCaseRef,
                })
            );
            dispatch(
                setReportProcedureModalState({
                    showReportProcedureModal: true,
                })
            );
            // dispatch(
            //     setOrderSummaryModalState({
            //         myCaseRef: rowData.myCaseRef,
            //         orderSummaryModal: false,
            //     })
            // );
            // dispatch(
            //     setOrderSummaryTabAction({
            //         selectedTabId: OrderSummaryTabs[8].id,
            //     })
            // );
            if (isSearchOrderList) {
                dispatch(
                    showHideSearchModalAction({
                        showSearchModal: false,
                    })
                );
            }
            // dispatch(
            //     setOrderSummaryModalState({
            //         myCaseRef: rowData.myCaseRef,
            //         orderSummaryModal: !orderSummaryModal,
            //     })
            // );
            dispatch(showHideProcedureModalAction(true));
        } else if (
            cta.ctaId === CTA_IDS.shippingTracking &&
            (rowData?.currentOrderType === 'ZOR' ||
                rowData?.currentOrderType === 'KB')
        ) {
            dispatch(
                setOrderSummaryTabAction({
                    selectedTabId: OrderSummaryTabs()[3].id,
                })
            );
            if (isSearchOrderList) {
                dispatch(
                    showHideSearchModalAction({
                        showSearchModal: false,
                    })
                );
            }
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef: rowData.myCaseRef,
                    orderSummaryModal: !orderSummaryModal,
                    isFromOrderHistory: isOrderHistory,
                })
            );
        } else if (cta.ctaId === 'CTA_026') {
            setTorqueQRParams({ myCaseRef: rowData.myCaseRef });
            setShowTorqueQR(true);
        } else {
            window.location.href = getWCMSRedirectionLink(rowData, cta);
        }
    };

    let colData =
        appliedCategory?.categoryName === 'Equity'
            ? [
                {
                    field: 'submitDate',
                    header: t('orders.orderStatuses.submiteddate'),
                    sortable: true,
                    width: iPad ? '13%' : '10%',
                    padding:
                        window.innerWidth === sizes.smalDevice ||
                            window.innerWidth === sizes.mediumDevice
                            ? '2px 2px 2px 14px'
                            : '2px 0px 0px 14px',
                },
                {
                    field: 'surgeryDate',
                    header: t('common.surgeryDateLabel'),
                    sortable: true,
                    width: iPad ? '10.5%' : '10%',
                    paddingLeft: '5px',
                },
                {
                    field: 'physicianDisplayName',
                    width: iPad ? '12%' : '12%',
                    sortable: true,
                },
                {
                    field: 'myCaseRef',
                    width: iPad ? '14%' : '12%',
                    sortable: true,
                },
                ...(isOrderHistory ? [{
                    field: 'sapOrderNumber',
                    header: 'SAP Order #',
                    sortable: true,
                    width: iPad ? '10%' : '10%',
                }] : []),
                {
                    field: 'account',
                    width: iPad ? '12.5%' : isOrderHistory ? '14%' : '16%',
                    sortable: true,
                },
                ...(!isOrderHistory ? [{
                    field: 'orderStatusDescription',
                    header: t('orders.orderListView.statusLabel'),
                    sortable: true,
                    width: iPad ? '14%' : '11%',
                }] : []),
                {
                    field: 'callToActionList',
                    header: 'Action',
                    sortable: false,
                    width: iPad ? '13%' : isOrderHistory ? '14%' : '13.5%',
                    className: 'orders-action-cell',
                    padding: '0px 2px 0px 1px',
                    paddingLeft: '0px',
                },
            ]
            : [
                {
                    field: 'submitDate',
                    header: t('orders.orderStatuses.submiteddate'),
                    sortable: true,
                    width:
                        window.innerWidth <= sizes.mediumDevice
                            ? '12.5%'
                            : '10%',
                    padding:
                        window.innerWidth <= 1024
                            ? '2px 2px 2px 14px'
                            : '2px 0px 0px 14px',
                },
                {
                    field: 'surgeryDate',
                    header: t('common.surgeryDateLabel'),
                    sortable: true,
                    width: iPad ? '10.5%' : '10%',
                    paddingLeft: '5px',
                },
                {
                    field: 'physicianDisplayName',
                    width: iPad ? '12%' : '12%',
                    sortable: true,
                },
                {
                    field: 'myCaseRef',
                    width: iPad ? '14%' : '12%',
                    sortable: true,
                },
                ...(isOrderHistory ? [{
                    field: 'sapOrderNumber',
                    header: 'SAP Order #',
                    sortable: true,
                    width: iPad ? '10%' : '10%',
                }] : []),
                {
                    field: 'account',
                    width: iPad ? '12.5%' : isOrderHistory ? '14%' : '16%',
                    sortable: true,
                },
                ...(!isOrderHistory ? [{
                    field: 'orderStatusDescription',
                    header: t('orders.orderListView.statusLabel'),
                    sortable: true,
                    width: iPad ? '14%' : '11%',
                }] : []),
                {
                    field: 'callToActionList',
                    header: 'Action',
                    sortable: false,
                    width: iPad ? '13%' : isOrderHistory ? '14%' : '13.5%',
                    className: 'orders-action-cell',
                    padding: '0px 2px 0px 1px',
                },
            ];

    colData = colData?.map((column) => {
        const extraProps = {
            bodyStyle: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                verticalAlign: isOrderHistory&&'top',
                padding: '10px 0',
            },
        };
        switch (column.field) {
            case 'callToActionList':
                extraProps.bodyStyle = {
                    ...extraProps.bodyStyle,
                    verticalAlign: 'middle',
                    padding: '0',
                };
                extraProps.header = (
                    <HeaderLeftBordered
                        borderLeft={'2px solid #ececec'}
                        showScrollBar={true}
                    >
                        <DemiText>
                            {t('orders.orderListView.actionLabel')}
                        </DemiText>
                    </HeaderLeftBordered>
                );
                extraProps.body = (rowData) => {
                    const primaryCTAId = getDefaultCTAId(rowData);
                    const primaryCTA = rowData.callToActionList?.find(
                        (item) => item.ctaId === primaryCTAId
                    );
                    const statusColor = orderStatusColorCode(
                        rowData.orderStatusDescription
                    );
                    const modelItems = rowData.callToActionList
                        ?.filter((item) => item.ctaId !== primaryCTAId)
                        .map((action) => {
                            return {
                                label: action.ctaName,
                                value: action.ctaId,
                                command: () => {
                                    setCtaData({
                                        ctaClicked: primaryCTA.ctaName,
                                        orderStatus:
                                            rowData?.orderStatusDescription,
                                    });
                                    if (
                                        primaryCTA.ctaId ===
                                        CTA_IDS.reportUsage ||
                                        (primaryCTA.ctaId ===
                                            CTA_IDS.editOrder &&
                                            ctaDetails.orderStatus ===
                                            t(
                                                'orders.orderQuickFilters.usageOrders.inProcess'
                                            ))
                                    ) {
                                        const SURGERYVALIDATEACCOUNT = {
                                            orderType: 'ZLB',
                                            sapPartnerId: rowData.accountNumber
                                                .toString()
                                                .padStart(10, '0'),
                                            myCaseRef: rowData.myCaseRef
                                            // territory: orderList.territoryId || 'NOT SELECTED',
                                            // district: orderList.districtId || 'NOT SELECTED'
                                        };
                                        dispatch(
                                            getValidateAccountDetails(
                                                SURGERYVALIDATEACCOUNT
                                            )
                                        );
                                    }

                                    handleCTAAction(action, rowData);
                                },
                            };
                        });
                    return (
                       <BodyContainer
                        id={`orders-list-bodyContainer-${rowData.myCaseRef}`}
                            color={statusColor}
                            /* Draw the status bar via absolutely-positioned element (full td height). */
                            style={{ padding: '10px 0 10px 10px', borderLeft: 'none' }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <OrdersActionStatusLine
                                aria-hidden="true"
                                style={{ backgroundColor: statusColor }}
                            />
                            {primaryCTA ? (
                                <FlexColumnContainer>
                                    <SplitButtonContainer
                                        id={
                                            props.isFromSearch
                                                ? 'orders-split-btn-cont'
                                                : 'orders-split-btn-cont-order'
                                        }
                                        label={primaryCTA.ctaName}
                                        value={primaryCTA.ctaId}
                                        onClick={() => {
                                            try {
                                            // For order history View, bypass all other logic and directly open summary
                                            if (isOrderHistory && primaryCTA.ctaName && primaryCTA.ctaName.toLowerCase().includes('view')) {
                                                dispatch(getConfigurations({ resourceType: 'visibility', module: fromOrderTypeToModuleName(rowData?.currentOrderType || rowData?.orderType, rowData?.isMastOrder, rowData?.isUsageMastOrder) }, ORDERS));
                                                dispatch(
                                                    setOrderSummaryTabAction({
                                                        selectedTabId: 'orderBasicDetails',
                                                    })
                                                );
                                                dispatch(
                                                    setOrderSummaryModalState({
                                                        myCaseRef: rowData.myCaseRef,
                                                        orderSummaryModal: true,
                                                        isFromOrderHistory: true,
                                                    })
                                                );
                                                dispatch(
                                                    setOrderStatus({
                                                        orderStatus: rowData.orderStatusDescription,
                                                    })
                                                );
                                                return;
                                            }
                                            if (primaryCTA.ctaId === CTA_IDS.viewOrder) {
                                                onRowClick(rowData);
                                                return;
                                            }
                                            dispatch(
                                                setCtaData({
                                                    ctaClicked: primaryCTA.ctaName,
                                                    orderStatus:
                                                        rowData?.orderStatusDescription,
                                                })
                                            );
                                            if (primaryCTA.ctaId === CTA_IDS.editOrder) {
                                                setIsEdit(true);
                                                //check for delivery eligibility
                                                if (deliveryCheckEdit === VISIBLE && rowData?.currentOrderType === 'ZLC') {
                                                    const deliveryCheckPayload = {
                                                        orderType: 'ZLC',
                                                        action: 'edit',
                                                        myCaseRef: rowData.myCaseRef
                                                    };
                                                    dispatch(
                                                        getCheckOrderActionEligibility(
                                                            deliveryCheckPayload
                                                        )
                                                    );
                                                }

                                            }

                                            if (
                                                (primaryCTA.ctaId ===
                                                    CTA_IDS.reportUsage) ||
                                                (primaryCTA.ctaId === CTA_IDS.reportPayment) ||
                                                (primaryCTA.ctaId ===
                                                    CTA_IDS.editOrder &&
                                                    ctaDetails.orderStatus ===
                                                    t(
                                                        'orders.orderQuickFilters.usageOrders.inProcess'
                                                    ))
                                            ) {
                                                const SURGERYVALIDATEACCOUNT = {
                                                    orderType: 'ZLB',
                                                    sapPartnerId:
                                                        rowData.accountNumber
                                                            .toString()
                                                            .padStart(10, '0'),
                                                    myCaseRef: rowData.myCaseRef
                                                    //territory: orderList.territoryId || 'NOT SELECTED',
                                                    //district: orderList.districtId || 'NOT SELECTED'
                                                };
                                                dispatch(
                                                    getValidateAccountDetails(
                                                        SURGERYVALIDATEACCOUNT
                                                    )
                                                );
                                                if (
                                                    !validateAccount?.data
                                                        ?.blockMessage
                                                ) {
                                                    setTempValidationData({
                                                        primary: primaryCTA,
                                                        row: rowData,
                                                    });
                                                }
                                            } else {
                                                handleCTAAction(
                                                    primaryCTA,
                                                    rowData
                                                );
                                            }
                                            } catch (error) {
                                               logErrorToConsole(error);
                                            }
                                        }}
                                        model={modelItems}
                                        dropdownIcon="pi pi-chevron-down"
                                        display={modelItems.length === 0 && 'none'}
                                        appendTo={
                                            modelItems.length > 0 ? '' : 'self'
                                        }
                                    />
                                   {rowData.torqueRecorded ? <Title color={PARKED_LABEL}>{t('orders.recordTorque.torqueRecorded')}</Title> : (qrGenerated[rowData.myCaseRef] || rowData?.qrGenerated) && <Title>{t('orders.recordTorque.qrGenerated')}</Title>}
                                </FlexColumnContainer>
                            ) : (
                                t('orders.orderListView.noActionMsg')
                            )}        
                        </BodyContainer>                  
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };

            case 'physicianDisplayName': {
                const physicianEvent = {
                    sortField: 'physicianDisplayName',
                    sortOrder: sortedOrder.physicianDisplaySort ? 1 : -1,
                };
                extraProps.header = (
                    <HeaderData id="orders-list-headerData-physician" onClick={() => onSort(physicianEvent)}>
                        <DemiText>
                            {t('orders.orderDetails.procedureData.physician')}
                        </DemiText>
                        <SmallHeaderText>
                            {t('ConsignmentAdd.submit.procedure')}
                        </SmallHeaderText>
                    </HeaderData>
                );
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <OrderListDataContainer
                                height="90%"
                                justifyContent="flex-start"
                                flexDirection="column"
                            >
                                <BoldTruncatedItem className="orders-table-physician-dt-mask" mdFontSize={'12px'}>
                                    {rowData.physicianDisplayName}
                                </BoldTruncatedItem>
                                {(countryISOCode === COUNTRY_CODE_JAPN &&
                                    rowData?.currentOrderType === 'KB' &&
                                    procedureTypeConsignmentAdd === 'ENABLED'
                                    ? true
                                    : countryISOCode === COUNTRY_CODE_JAPN &&
                                        rowData?.currentOrderType === 'KE' &&
                                        procedureVisibilityKE === 'ENABLED'
                                        ? true
                                        : countryISOCode === COUNTRY_CODE_JAPN &&
                                            rowData?.currentOrderType !== 'KE' &&
                                            rowData?.currentOrderType !== 'KB'
                                            ? true
                                            : countryISOCode !== COUNTRY_CODE_JAPN) && (
                                        <RegularTruncateText mdFontSize={'12px'}>
                                            {rowData.procedureDescription}
                                        </RegularTruncateText>
                                    )}
                                {/* //  : (
                                //     <RegularTruncateText mdFontSize={'12px'}>
                                //         {rowData.procedureDescription}
                                //     </RegularTruncateText> */}
                            </OrderListDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }
            case 'myCaseRef': {
                const myCaseRefEvent = {
                    sortField: 'myCaseRef',
                    sortOrder: sortedOrder.mCaseRefSort ? 1 : -1,
                };
                extraProps.header = (
                    <HeaderData id="orders-list-headerData-myCaseRef" onClick={() => onSort(myCaseRefEvent)}>
                        <DemiText>
                            {t('orders.orderListView.myCaseRefLabel')}
                        </DemiText>
                        {(
                            <SmallHeaderText>
                                {t('orders.orderListView.patientLabel')}
                            </SmallHeaderText>
                        )}
                    </HeaderData>
                );

                extraProps.body = (rowData) => {
                    return (
                        <>
                            <OrderListDataContainer
                                height="90%"
                                justifyContent="flex-start"
                                flexDirection="column"
                                padding="0 4px"
                            >
                                <CaseRefText
                                    mdFontSize={'12px'}
                                    cursor={'pointer'}
                                >
                                    {rowData.myCaseRef}
                                </CaseRefText>
                                {
                                    // patientInformationVisibility === VISIBLE &&
                                    rowData.patientName
                                        // &&
                                        // reportUsagePatientDetails?.includes(
                                        //     'Patient Name'
                                        // ) 
                                        ? (
                                            <RegularTruncateText
                                                className="orders-table-patient-name-dt-mask"
                                                height="21px"
                                                lineHeight={'21px'}
                                                mdFontSize={'12px'}
                                            >
                                                {rowData.patientName}
                                            </RegularTruncateText>
                                        ) : (
                                            <RegularTruncateText
                                                height="21px"
                                                lineHeight={'21px'}
                                            ></RegularTruncateText>
                                        )}
                                {rowData?.noOfSets ? (
                                    <SetContainer
                                        isSetVisible={rowData.noOfSets}
                                        width={'max-content'}
                                    >
                                        {rowData.noOfSets}{' '}
                                        {`${rowData.noOfSets > 1
                                            ? t('common.setsLabel')
                                            : t('common.setLabel')
                                            }`}
                                    </SetContainer>
                                ) : (
                                    <RegularTruncateText height="20px"></RegularTruncateText>
                                )}
                            </OrderListDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }

            case 'sapOrderNumber': {
                extraProps.body = (rowData) => {
                    const orderTypeLabel = (orderType, sapOrderIsMast = false) => {
                        if (orderType === 'ZLCR') {
                            return t('orders.orderTypes.replenishment');
                        }
                        if (orderType === 'ZLC') {
                            return fromOrderTypeToLabel(orderType, sapOrderIsMast);
                        }
                        const match = (ConstantOrderTypeFilter() || []).find(
                            (entry) => Array.isArray(entry?.orderType) && entry.orderType.includes(orderType)
                        );
                        return match?.orderTypeName || orderType || '';
                    };

                    const sapOrders = Array.isArray(rowData?.sapOrderList)
                        ? rowData.sapOrderList
                        : rowData?.sapOrderNumber
                            ? [
                                {
                                    sapOrderNo: rowData.sapOrderNumber,
                                    orderType: rowData?.currentOrderType,
                                },
                            ]
                            : [];

                    return (
                        <OrderListDataContainer
                            height="auto"
                            justifyContent="flex-start"
                            flexDirection="column"
                            padding="0 4px"
                        >
                            {sapOrders.length > 0 ? (
                                sapOrders.map((order, idx) => (
                                    <div
                                        key={`${order?.sapOrderNo || 'sap'}-${order?.orderType || 'type'}-${idx}`}
                                        style={{
                                            marginBottom:
                                                idx === sapOrders.length - 1
                                                    ? '0px'
                                                    : '8px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: 'grid',
                                                gridTemplateColumns: '24px 1fr',
                                                columnGap: '6px',
                                                rowGap: '2px',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {order?.orderType === 'ZLCR' ? (
                                                <OrderTypeSpanContianer
                                                    sourcePath={ReplenishIcon}
                                                    ipadSourcePath={ReplenishIcon}
                                                    marginLeft={'0px'}
                                                    marginRight={'0px'}
                                                />
                                            ) : order?.isTissue || order?.isNonTissue ? (
                                                <OrderTypeSpanContianer
                                                    sourcePath={
                                                        order?.isTissue
                                                            ? TissueIconsmall
                                                            : NonTissueIconsmall
                                                    }
                                                    ipadSourcePath={
                                                        order?.isTissue
                                                            ? TissueIconsmall
                                                            : NonTissueIconsmall
                                                    }
                                                    marginLeft={'0px'}
                                                    marginRight={'0px'}
                                                />
                                            ) : (
                                                <div />
                                            )}

                                            <RegularTruncateText
                                                mdFontSize={'12px'}
                                                lineHeight={'16px'}
                                            >
                                                {order?.sapOrderNo || ''}
                                            </RegularTruncateText>

                                            <div />
                                            <RegularTruncateText
                                                mdFontSize={'12px'}
                                                lineHeight={'16px'}
                                                color={PINK_HIGHLIGHT_COLOR}
                                            >
                                                {orderTypeLabel(
                                                    order?.orderType,
                                                    order?.isMastOrder ?? rowData?.isMastOrder
                                                )}
                                            </RegularTruncateText>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <RegularTruncateText height="21px" lineHeight={'21px'} />
                            )}
                        </OrderListDataContainer>
                    );
                };

                return {
                    ...column,
                    ...extraProps,
                };
            }

            case 'account': {
                const accountEvent = {
                    sortField: 'account',
                    sortOrder: sortedOrder.accountSort ? 1 : -1,
                };
                extraProps.header = (
                    <HeaderData  id="orders-list-headerData-account" onClick={() => onSort(accountEvent)}>
                        <DemiText>
                            {t('reportUsage.record.account.title')}
                        </DemiText>
                        {(
                            <SmallHeaderText>
                                {t('common.hrefLabel')}
                            </SmallHeaderText>
                        )}
                    </HeaderData>
                );
                extraProps.body = (rowData) => {
                    return (
                        <>
                            <OrderListDataContainer
                                height="90%"
                                justifyContent="flex-start"
                                flexDirection="column"
                                padding="0 4px"
                            >
                                <AccountNameNumberText
                                    mdMargin={'0 0 6px 0'}
                                    mdFlexDirection={'column'}
                                    flexDirection={'row'}
                                    style={{ width: '97%' }}
                                >
                                    <LabelFont
                                        className="orders-table-account-name-dt-mask"
                                        textOverflow={'ellipsis'}
                                        mdDisplay={'-webkit-box'}
                                        mdOrient={'vertical'}
                                        overflow={'hidden'}
                                        // width={'70%'}
                                        lineHeight={'16px'}
                                        fontFamily={'AvenirNextWorld Regular'}
                                        fontSize={'13px'}
                                        mdFontSize={'12px'}
                                        color={'#070707'}
                                        mdLineClamp={2}
                                        mdWidth={'100%'}
                                        padding={'0px 4px 0px 0px'}
                                        mdWhiteSpace={'normal'}
                                        whiteSpace={'nowrap'}
                                    >
                                        {rowData.accountName}
                                    </LabelFont>

                                    <LabelFont
                                        className="orders-table-account-number-dt-mask"
                                        mdWidth={'100%'}
                                        lineHeight={'16px'}
                                        fontFamily={'AvenirNextWorld Regular'}
                                        fontSize={'13px'}
                                        mdFontSize={'12px'}
                                        mdFontStyle={'italic'}
                                        color={'#070707'}
                                    // width={'30%'}
                                    >
                                        {parseInt(rowData.accountNumber)}
                                    </LabelFont>
                                </AccountNameNumberText>
                                {
                                    // patientIdVisibility === VISIBLE &&
                                    rowData.hrefId
                                        // &&
                                        // reportUsagePatientDetails?.includes(
                                        //     'Hospital Patient Ref'
                                        // ) 
                                        ? (
                                            <UNiDContainer>
                                                {/* <UNiDText>HREF </UNiDText> */}
                                                <RegularTruncateText
                                                    className="orders-table-href-id-dt-mask"
                                                    color="#140F4B"
                                                    fontSize="12px"
                                                >
                                                    {rowData.hrefId}
                                                </RegularTruncateText>
                                            </UNiDContainer>
                                        ) : (
                                            <RegularTruncateText height="13px"></RegularTruncateText>
                                        )}
                                {rowData.unidCaseId ? (
                                    <div id={`orders-list-unidItem-${rowData.myCaseRef}`} onClick={(e) => e.stopPropagation()}>
                                        <UnidItem
                                            uniDIdUrl={rowData.unidIdURL}
                                            uniDId={rowData.unidCaseId}
                                            planStatus={rowData.unidPlanDetails}
                                            showPlan={rowData.isMtoStatus}
                                            textOverflow={'ellipsis'}
                                            overflow={'hidden'}
                                            width={'100%'}
                                        />
                                    </div>
                                ) : (
                                    <UNiDContainer height="13px"></UNiDContainer>
                                )}
                                {rowData.secondaryVendorCaseNo ? (
                                    <div style={{ display: 'flex' }}>
                                        <RegularText
                                            color="#4F4F4F"
                                            fontSize="12px"
                                            style={{ marginRight: '1px' }}
                                        >
                                            {t('common.vendorLabel')}
                                        </RegularText>
                                        <DemiText
                                            color="#1010EB"
                                            fontSize="12px"
                                            margin="0 2px 0 2px"
                                            style={{
                                                overflowX: 'auto',
                                                textOverflow: 'ellipsis',
                                            }}
                                        >
                                            {rowData.secondaryVendorCaseNo}
                                        </DemiText>
                                    </div>
                                ) : null}
                            </OrderListDataContainer>
                        </>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }
            case 'orderStatusDescription': {
                const statusEvent = {
                    sortField: 'orderStatusDescription',
                    sortOrder: sortedOrder.orderStatusDescription ? 1 : -1,
                };
                extraProps.header = (
                    <HeaderData  id="orders-list-headerData-status" onClick={() => onSort(statusEvent)}>
                        <DemiText>
                            {t('orders.orderListView.statusLabel')}
                        </DemiText>
                        <SmallHeaderText lineHeight={'13px'}>
                            {t('orders.orderListView.usageAmount')}
                        </SmallHeaderText>
                    </HeaderData>
                );
                extraProps.body = (rowData) => {
                    const currentDate = getDisplayDate(new Date());
                    const submitFormattedDate = getDisplayDate(
                        new Date(rowData.submitDate)
                    );
                    let diffTime =
                        new Date(currentDate).getTime() -
                        new Date(submitFormattedDate).getTime();
                    const diffDays = Math.ceil(
                        diffTime / (1000 * 60 * 60 * 24)
                    );
                    return (
                        <OrderListDataContainer
                            height="90%"
                            alignItems="flex-start"
                            padding="0 5px"
                            flexDirection={'column'}
                        >
                            <OrderListDataContainer alignItems={'center'}>
                                <LabelFont
                                    fontFamily={'AvenirNextWorld Demi'}
                                    fontSize="12px"
                                    color={
                                        (rowData.orderStatusDescription ===
                                            t(
                                                'orders.orderQuickFilters.usageOrders.awaitingPO.statusNotes.paymentInformationNeeded'
                                            ) ||
                                            rowData.orderStatusDescription ===
                                            t(
                                                'calendar.actionPanel.awaitingPO'
                                            )) &&
                                            diffDays > 30
                                            ? '#EB475B'
                                            : '#3C3C3C'
                                    }
                                    lineHeight={'16px'}
                                    textOverflow={'ellipsis'}
                                    display={'flex'}
                                    lineClamp={2}
                                    orient={'vertical'}
                                    overflow={'hidden'}
                                    alignItems={'center'}
                                >
                                    {(rowData.orderStatusDescription ===
                                        t(
                                            'orders.orderQuickFilters.usageOrders.awaitingPO.statusNotes.paymentInformationNeeded'
                                        ) ||
                                        rowData.orderStatusDescription ===
                                        t(
                                            'calendar.actionPanel.awaitingPO'
                                        )) &&
                                        diffDays > 30 ? (
                                        <img
                                            src={AlertCircle}
                                            alt="alertCircle"
                                            height={'24px'}
                                            width={'24px'}
                                        />
                                    ) : null}
                                    {rowData.orderStatusDescription}
                                </LabelFont>
                                <DemiText>
                                    {rowData.orderStatusColor ===
                                        'status-error' ? (
                                        <MdiOptions imageSrc={AlertIcons} />
                                    ) : null}
                                    {rowData.orderStatusColor ===
                                        'status-warning' ? (
                                        <MdiOptions
                                            imageSrc={AlertIconYellow}
                                        />
                                    ) : null}
                                </DemiText>
                            </OrderListDataContainer>
                            <OrderListDataContainer
                                margin={'5px 0 0 0'}
                                flexDirection={'column'}
                            >
                                {rowData?.currentOrderType == 'ZLC' &&
                                    rowData?.isNonTissueExists &&
                                    rowData?.countryCode == 'US' ? (
                                    <OrderTypeSpanContianer
                                        sourcePath={NonTissueIcon}
                                        ipadSourcePath={NonTissueIconsmall}
                                        marginRight={'3px'}
                                        marginLeft={'0px'}
                                    />
                                ) : null}
                                {rowData?.currentOrderType == 'ZLC' &&
                                    rowData?.isTissueExists &&
                                    rowData?.countryCode == 'US' ? (
                                    <>
                                        <OrderTypeSpanContianer
                                            sourcePath={TissueIcon}
                                            ipadSourcePath={TissueIconsmall}
                                            marginRight={'3px'}
                                            marginLeft={'0px'}
                                            marginTop={
                                                rowData?.isNonTissueExists
                                            }
                                        />
                                    </>
                                ) : null}
                                {rowData?.nonTissuePriceList ? (
                                    <PriceTag
                                        isUSUser={countryISOCode == 'US'}
                                        width={'fit-content'}
                                        mobileMarginTop={'0%'}
                                        desktopMarginTop={'0px'}
                                        priceArray={rowData.nonTissuePriceList}
                                        nonTissue={true}
                                        isInvoiceStatus
                                        invoiceDataMargin={
                                            rowData.nonTissuePriceList &&
                                            rowData.tissuePriceList &&
                                            '0 0.5rem 0 0'
                                        }
                                        priceFontSize={'11px'}
                                        countDisplay={'none'}
                                        marginRightImage={'3px'}
                                        marginLeftImage={'0px'}
                                        currencyFont={'11px'}
                                        isListView={true}
                                        isPriceOverride={
                                            rowData?.nonTissuePriceAndOverride
                                                ?.length > 0
                                                ? checkPriceOverRideOrderAmount(
                                                    rowData.nonTissuePriceAndOverride
                                                )
                                                : false
                                        }
                                    />
                                ) : null}
                                {rowData?.tissuePriceList ? (
                                    <PriceTag
                                        isUSUser={countryISOCode == 'US'}
                                        width={'fit-content'}
                                        mobileMarginTop={'0%'}
                                        desktopMarginTop={'0px'}
                                        priceArray={rowData.tissuePriceList}
                                        nonTissue={false}
                                        isInvoiceStatus
                                        invoiceDataMargin={
                                            rowData.nonTissuePriceList &&
                                            rowData.tissuePriceList &&
                                            '0 0.5rem 0 0'
                                        }
                                        priceFontSize={'11px'}
                                        countDisplay={'none'}
                                        marginRightImage={'3px'}
                                        marginLeftImage={'0px'}
                                        currencyFont={'11px'}
                                        isListView={true}
                                        isPriceOverride={
                                            rowData?.tissuePriceAndOverride
                                                ?.length > 0
                                                ? checkPriceOverRideOrderAmount(
                                                    rowData.tissuePriceAndOverride
                                                )
                                                : false
                                        }
                                    />
                                ) : null}
                            </OrderListDataContainer>
                        </OrderListDataContainer>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            }

            case 'surgeryDate':
                extraProps.body = (rowData) => {
                    return (
                        <OrderListDataContainer
                            height="90%"
                            alignItems="flex-start"
                            padding={'0 0 0 5px'}
                        >
                            {rowData.surgeryDate &&
                                rowData.surgeryDate !== 'Invalid Date' ? (
                                <RegularText color="#3C3C3C" fontSize="12px">
                                    {getDisplayDate(
                                        // new Date(
                                        //     rowData.surgeryDate.includes('2050')
                                        //         ? rowData.surgeryDate.replace(
                                        //               'Z',
                                        //               ''
                                        //           )
                                        //         : rowData.surgeryDate
                                        // )
                                        new Date(rowData.surgeryDate)
                                    )}
                                </RegularText>
                            ) : (
                                <RegularText color="#000000" fontSize="12px">
                                    {'NA'}
                                </RegularText>
                            )}
                        </OrderListDataContainer>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            case 'submitDate':
                extraProps.body = (rowData) => {
                    return (
                        <OrderListDataContainer
                            height="90%"
                            alignItems="flex-start"
                            flexDirection="column"
                            padding="0 14px"
                        >
                            <RegularText color="#000000" fontSize="12px">
                                {getDisplayDate(new Date(rowData.submitDate))}
                            </RegularText>
                            <RegularText color="#C529BB" fontSize="11px">
                                {fromOrderTypeToLabel(
                                    rowData?.currentOrderType,
                                    rowData.isMastOrder
                                )}
                            </RegularText>
                        </OrderListDataContainer>
                    );
                };
                return {
                    ...column,
                    ...extraProps,
                };
            default:
                return {
                    ...column,
                    ...extraProps,
                };
        }
    });

    const onPageChange = (event) => {
        if (isSearchOrderList) {
            searchPageChangeHandler(event);
        } else {
            setFirst(event.first);
            setPage(event.page);
            setPageControl(true);
        }
    };
    const onSort = (event) => {
        if (isOrderHistory && event.sortField !== 'submitDate') {
            return;
        }
        if (isSearchOrderList) {
            searchSortHandler(event);
        } else {
            setSortParam(event.sortField);
            setSortOrder(event.sortOrder);
            setSortControl(true);
        }
        setSortedOrder({
            ...sortedOrder,
            accountSort:
                event.sortField === 'account'
                    ? !sortedOrder.accountSort
                    : false,
            mCaseRefSort:
                event.sortField === 'myCaseRef'
                    ? !sortedOrder.mCaseRefSort
                    : false,
            physicianDisplaySort:
                event.sortField === 'physicianDisplayName'
                    ? !sortedOrder.physicianDisplaySort
                    : false,
            orderStatusDescription:
                event.sortField === 'orderStatusDescription'
                    ? !sortedOrder.orderStatusDescription
                    : false,
        });
    };

    const onRowClick = (data) => {
        //added for equity
        if (
            data?.currentOrderType === 'ZLB' ||
            data?.currentOrderType === 'ZLC' ||
            data?.currentOrderType === 'KE' ||
            data?.currentOrderType === 'ZOR' ||
            data?.currentOrderType === 'ZKA' ||
            data?.currentOrderType === 'KB' ||
            data?.currentOrderType === 'CR' ||
            data?.currentOrderType === 'ZWR' ||
            data?.currentOrderType === 'ZFKB' ||
            data?.currentOrderType === 'ZTR' ||
            data?.currentOrderType === 'DR' ||
            data?.currentOrderType === 'ZCC' ||
            data?.currentOrderType === 'ZLBR' ||
            data?.currentOrderType === 'ZCC1' ||
            data?.currentOrderType === 'G2' ||
            data?.currentOrderType === 'L2'
        ) {
            if (isSearchOrderList) {
                dispatch(getConfigurations({ resourceType: 'visibility', module: fromOrderTypeToModuleName(data?.currentOrderType, data?.isMastOrder, data?.isUsageMastOrder) }, ORDERS));
                dispatch(
                    setOrderSummaryModalState({
                        myCaseRef: data.myCaseRef,
                        orderSummaryModal: !orderSummaryModal,
                        isFromOrderHistory: isOrderHistory,
                    })
                );
                dispatch(toggleSearchResult(true));
                // props.searchOrderResultsClose();
            } else {
                openOrderSummaryHandler(data.myCaseRef, data?.currentOrderType, data.isUsageMastOrder, data.isMastOrder);
            }
            dispatch(
                setOrderStatus({
                    orderStatus: data.orderStatusDescription,
                })
            );
        } else {
            window.location.href = getWCMSRedirectionLink(data, {
                ctaId: CTA_IDS.viewOrder,
            });
        }
    };
    const sortMarginIpad =
        innerWidth >= sizes.smalDevice && innerWidth <= sizes.mediumDevice
            ? '3px'
            : '2px';
    const scrollHeightIpad = scrollHeightWithFilters
        ? 530
        : scrollHeightNoQuickFilter
            ? 400
            : scrollNoAppliedFilters
                ? 515
                : 360;
    const scrollHeightDesktop = scrollHeightWithFilters
        ? appliedCategory.categoryName === 'Drafts'
            ? 440
            : innerHeight > sizes.mediumDevice
                ? props.parentRef[2]?.current
                    ? +getRefTotalHeight(props.parentRef[2].current).slice(0, -2) >
                        61
                        ? 520
                        : 500
                    : 480
                : 480
        : scrollHeightNoQuickFilter
            ? 380
            : scrollNoAppliedFilters
                ? appliedCategory.categoryName === 'Drafts'
                    ? 400
                    : innerHeight > sizes.mediumDevice
                        ? props.parentRef[2]?.current
                            ? +getRefTotalHeight(props.parentRef[2].current).slice(0, -2) >
                                61
                                ? 480
                                : 460
                            : 441
                        : 441
                : 340;

    const finalScrollHeight =
        innerHeight >= sizes.smalDevice && innerHeight <= sizes.ipad9thGenHeight
            ? scrollHeightIpad
            : scrollHeightDesktop;

    const [hasFilter, setHasFilter] = useState(
        scrollHeightNoQuickFilter || scrollNoAppliedFilters
    );

    useEffectWithErrorLogging(() => {
        setHasFilter(scrollHeightNoQuickFilter || scrollNoAppliedFilters);
    }, [scrollHeightNoQuickFilter, scrollNoAppliedFilters]);


    const [tableHeight, setTableHeight] = useState('');
    const [dTableHeight, setDTableHeight] = useState('');
    const [searchTableHeight, setSearchTableHeight] = useState('');
    const paginationHeight =
        (isLanguageChanged &&
            !appliedCategory?.categoryName?.includes('下書き') &&
            !appliedCategory?.categoryName?.includes('MAST'))
            ? 30
            : (isLanguageChanged &&
                appliedCategory?.categoryName?.includes('下書き') ||
                appliedCategory?.categoryName?.includes('MAST'))
                ? -20
                : (!isLanguageChanged && appliedCategory?.categoryName === '')
                    ? 10
                    : (!isLanguageChanged &&
                        (appliedCategory?.categoryName?.includes('Drafts') ||
                            appliedCategory?.categoryName?.includes('MAST')))
                        ? 10
                        : 15;

    useEffectWithErrorLogging(() => {
        // eslint-disable-next-line no-unused-vars
        const { deviceName, deviceType, browser } = detectDeviceInfo();
        const bufferSpace = hasFilter
            ? window.innerWidth < sizes.mediumDevice
                ? browser === 'Safari'
                    ? 'calc(4rem + 170px)'
                    : 'calc(4rem + 160px)'
                : browser === 'Edge'
                    ? 'calc(4rem + 110px)'
                    : browser === 'Safari'
                        ? 'calc(4rem + 150px)'
                        : 'calc(4rem + 160px)'
            : window.innerWidth < sizes.mediumDevice
                ? browser === 'Safari'
                    ? 'calc(14rem)'
                    : 'calc(15rem)'
                : browser === 'Edge'
                    ? 'calc(12rem)'
                    : browser === 'Safari'
                        ? 'calc(14rem)'
                        : 'calc(15rem)';
        const bennerHeightVaue = bannerHeight ? bannerHeight?.split('px')[0] : 0;
        let topHeight = 0;
        (props.parentRef || []).forEach((it) => {
            //(it) => (topHeight += +getRefTotalHeight(it.current).slice(0, -2));
            topHeight += +getRefTotalHeight(it.current).slice(0, -2);
        });
        const headerHeight = '130'; //Mycase Header 65px + Order Header 50+10+5
        if (!topHeight) {
            topHeight = 320;
        }

        const tableHeight = `calc(100vh - ${topHeight}px - ${bennerHeightVaue}px - ${bufferSpace} - ${headerHeight}px)`;
        setTableHeight(tableHeight);
        const poContainer = props.parentRef[2]?.current
            ? +getRefTotalHeight(props.parentRef[2].current).slice(0, -2)
            : 0;
        const bannerlessHeight = scrollHeight
            ? innerHeight - finalScrollHeight - poContainer
            : innerHeight - 320 - poContainer;
        const height = bannerlessHeight - bennerHeightVaue - paginationHeight + 'px';
        setDTableHeight(height);
    }, [
        innerHeight,
        bannerHeight,
        scrollHeight,
        finalScrollHeight,
        hasFilter,
        props.parentRef,
        formattedOrders,
        page,
    ]);
    useEffectWithErrorLogging(() => {
        if (isSearchOrderList) {
            let searchBufferSpace = 175; //dialog padding top, table header, table pagination, buffer space
            searchBufferSpace += props.searchRefHeader //search header space,
                ? +props.searchRefHeader
                : 0;
            searchBufferSpace += props.searchRefResult //search result space,
                ? +props.searchRefResult
                : 0;
            const searchContainerHeight = props?.searchRefHeight
                ? props.searchRefHeight
                : 500;

            const searchTblHeight = searchContainerHeight - searchBufferSpace - paginationHeight;
            setSearchTableHeight(`${searchTblHeight}px`);
        } else {
            setSearchTableHeight('');
        }
    }, [
        props.searchRefHeight,
        props.searchRefHeader,
        props.searchRefResult,
        isSearchOrderList,
        innerHeight,
    ]);

    const orderLockedViewBtnClickHandler = async () => {
        if (!(await closeOrderActionPopup())) return;
        if (isSearchOrderList) {
            dispatch(
                setOrderSummaryModalState({
                    myCaseRef:
                        usageProcessingPopup?.myCaseRef ||
                        showOrderLockedPopup?.myCaseRef,
                    orderSummaryModal: !orderSummaryModal,
                    isFromOrderHistory: isOrderHistory,
                })
            );
            dispatch(toggleSearchResult(true));
            // props.searchOrderResultsClose();
        } else {
            openOrderSummaryHandler(
                usageProcessingPopup?.myCaseRef || showOrderLockedPopup?.myCaseRef
            );
        }
        // openOrderSummaryHandler(showOrderLockedPopup?.myCaseRef);
    };

    const handleCloseDeliveryCheckPopUp = (status) => {
        dispatch(getCheckOrderActionEligibilityReset());
        // unlockOrderFunc({
        //     action: 'NoUsageToReport',
        //     myCaseRefId: myCaseRef || tableRowData?.myCaseRef,
        // });
        const myCaseRefId = myCaseRef || tableRowData?.myCaseRef;
        (myCaseRefId && myCaseRefId?.length) && unlockOrderFunc({
           action: status === 'edit' ? 'SubmittedSurgeryEdit' : 'NoUsageToReport',
            myCaseRefId: myCaseRefId,
        });

        setTableRowData(null);
    };

    const handleNoReportUsageCancellation = (myCaseRef) => {
        dispatch(
            cancelUsageOrderRequest(
                { myCaseRef: myCaseRef },
                true,
                false
            )
        );
        dispatch(getCheckOrderActionEligibilityReset());
    };

      const closeQrCodePopup = (requestParams) => {
             try {
                const myCaseRef = requestParams?.myCaseRef;
                    setShowTorqueQR(false);
                    if(myCaseRef && !qrGenerated[myCaseRef]) {
                            dispatch(setQrGenerated({ [myCaseRef]: true }));
                        }
                    } catch (error) {
                        logErrorToConsole(error);
                    }
        };

    return (
        <OrdersListViewContainer>
            {loading ? null : (
                <Datatable
                    id={'orders-ordersListTableView-list'}
                    onHideScrolling={hideScrolling}
                    onResumeScrolling={resumeScrolling}
                    backgroundColorOdd={'#FFFFFF99'}
                    backgroundColorEven={'#F5F5F5'}
                    backgroundColorPagination={
                        isSearchOrderList ? 'transparent' : '#F5F5F5'
                    }
                    resizableColumns
                    columns={colData}
                    data={formattedOrders}
                    totalRecords={+totalNumberOfRecords}
                    rows={PAGE_LIMIT}
                    paginator={disablePaginator ? false : true}
                    first={isSearchOrderList ? searchFirst : first}
                    onPageChange={onPageChange}
                    onSort={onSort}
                    sortField={isSearchOrderList ? searchSortParam : sortParam}
                    sortOrder={isSearchOrderList ? searchSortOrder : sortOrder}
                    onRowClick={(event) => onRowClick(event.data)}
                    scrollHeight={
                        isSearchOrderList
                            ? searchTableHeight
                            : iPad
                                ? tableHeight
                                : dTableHeight
                    }
                    scrollable
                    isListView
                    sortMargin={sortMarginIpad}
                    displayType={'inline-table'}
                    isOrderHistory={isOrderHistory}
                    columnHeight={isOrderHistory ? 'auto' : undefined}
                    height={'100px'}
                    rightCOntentMarginTop={5}
                />
            )}
            {deleteNotAllowedPopupOpen && (
                <UnidHubOrderDeletePopup
                  id="orders-list-unidHubOrderDeletePopup"
                    onClose={() => {
                        try {
                        setDeleteNotAllowedPopupOpen((prev) => !prev);
                        } catch (error) {
                           logErrorToConsole(error);
                        }
                    }}
                />
            )}
              {retriggerEventNotification&&(<UnsavedChanges isFromSummary={true} isFromOrderListingPage={true}
                onDiscard={() => handleEventRetrigger(notificationDetails,retriggerEventNotification==='fromSummary'&&true)}
                    onClose={() =>{
                        setRetriggerEventNotification(false);
                        setNotificationDetails({});}
                    }
                    />)}
            {blockedAccountMessagePopUp &&
                validateAccount?.data?.blockMessage ? (
                <MessageTemplate
                    isDeliveryCheck={true}
                    onClose={() => {
                        try {
                        dispatch(resetValidateAccountDetails());
                        setBlockedAccountMessagePopUp(false);
                        } catch (error) {
                           logErrorToConsole(error);
                        }
                    }}
                    content={validateAccount?.data?.blockMessage}
                    width={'100%'}
                    marginB={'32px'}
                    position={'static'}
                    height={'auto'}
                    title={t(
                        'ConsignmentAdd.surgery.notifications.accountBlocked'
                    )}
                    fontWeight={'800'}
                    blocked
                    background={'None'}
                />
            ) : null}
            {(usageProcessingPopup || showOrderLockedPopup.show) && (
                <CancelAlertPopup
                    id="orders-list-cancelAlertPopup-orderLocked"
                    fitContent={!!usageProcessingPopup}
                    popupTitle={t(
                        usageProcessingPopup
                            ? 'orders.shipTrackLabels.usageProcessingTitle'
                            : 'orders.shipTrackLabels.lockededit'
                    )}
                    alertMessage={
                        usageProcessingPopup
                            ? t('orders.shipTrackLabels.usageProcessingMessage', {
                                  orderNumber: usageProcessingPopup.myCaseRef,
                                  userId: usageProcessingPopup.userId,
                              })
                            : `${t('orders.shipTrackLabels.mycaseorder')} ${showOrderLockedPopup.myCaseRef
                        } ${t('orders.shipTrackLabels.msg')} ${showOrderLockedPopup.modifiedBy
                        }.`}
                    btn1Label={t('reportUsage.common.cancel')}
                    cancelBtn
                    btn2Label={
                        (usageProcessingPopup || showOrderLockedPopup)?.action !==
                            'DraftUsageEdit' &&
                        t('calendar.filterResultsPanel.viewLabel')
                    }
                    btnCloseClickHandler={closeOrderActionPopup}
                    btn1ClickHandler={closeOrderActionPopup}
                    btn2ClickHandler={orderLockedViewBtnClickHandler}
                />
            )}
            {requestInvoiceState &&
                (isRequestInvoiceOrderListPage ||
                    isRequestInvoiceSearchListPage) && (
                    <RequestInvoice
                        onCloseRequestInvoiceHandler={() => {
                            try {
                            if (isRequestInvoiceSearchListPage) {
                                dispatch(
                                    showHideSearchModalAction({
                                        showSearchModal: true,
                                    })
                                );
                            }
                            dispatch(
                                showHideRequestInvoice({
                                    requestInvoiceState: false,
                                    myCaseRefId: '',
                                    isRequestInvoiceOrderListPage: false,
                                    isRequestInvoiceSearchListPage: false,
                                })
                            );
                            } catch (error) {
                                   logErrorToConsole(error);
                            }
                        }}
                    />
                )}
            {showViewTemplate && tableRowData && (
                <>
                    <ModalDialog
                        marginTop={'16.2rem'}
                        overflowX={'hidden'}
                        maxWidth={'841px'}
                        crossMarginTop={'15px'}
                        handleClose={toggleViewTemplate}
                        zIndex={dialogZindex}
                        paddingBottom={'190px'}
                        padding={'16px 3px 16px 16px'}
                        isMobileDevice={true}
                        afterSubmitTemplate={false}
                    >
                        {tableRowData?.currentOrderType === 'ZOR' ? (
                            <CreateEquityTemplate
                                handleClose={toggleViewTemplate}
                                orderData={tableRowData?.myCaseRef}
                                orderType={tableRowData?.currentOrderType}
                                origin={'orders'}
                                isFromOrderHistory={isOrderHistory}
                                onOpen={() => {
                                    try {
                                    setDialogZindex(2000);
                                    //onSelectOpen();
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                }}
                                onClose={() => {
                                    try {
                                    setDialogZindex(10000);
                                    //onSelectClose();
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                }}
                            />
                        ) : (
                            <CreateTemplate
                                handleClose={toggleViewTemplate}
                                orderData={tableRowData?.myCaseRef}
                                orderType={tableRowData?.currentOrderType}
                                origin={'orders'}
                                isFromOrderHistory={isOrderHistory}
                                onOpen={() => {
                                    try {
                                    setDialogZindex(2000);
                                    //onSelectOpen();
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                }}
                                onClose={() => {
                                    try {
                                    setDialogZindex(10000);
                                    //onSelectClose();
                                    } catch (error) {
                                      logErrorToConsole(error);
                                    }
                                }}
                                templateMandatoryFields={checkTemplateReviewUserRoleChanges(
                                    employeeRole,
                                    SURGERY_TEMPLATE_MANDATORY_FIELDS
                                )}
                            />
                        )}
                    </ModalDialog>
                </>
            )}
            {showTorqueQR && (
                <ModalDialog
                    handleClose={() =>closeQrCodePopup(torqueQRParams)}
                     zIndex={2000}
                     paddingBottom={'16px'}
                     paddingTop={'16.2rem'}
                     overflowX={'hidden'}
                    crossMarginTop={'15px'}
                    modalHeight={'396px'}
                    padding={'1px'}
                    maxWidth={'450px'}
                    isMobileDevice={true}
                >
                    <TorqueQRCode
                        requestParams={torqueQRParams}
                        qrCodeData={qrCodeData}
                        qrCodeLoading={qrCodeLoading}
                        qrCodeError={qrCodeError}
                        setShowTorqueQR={setShowTorqueQR}
                        qrGenerated={qrGenerated}
                        onClose={() =>closeQrCodePopup(torqueQRParams)}
                    />
                </ModalDialog>
            )}
            {!isAllowed && statusCode === '13202' && (
                <MessageTemplate
                    isDeliveryCheck={true}
                    onClose={() => {
                        try {
                        handleCloseDeliveryCheckPopUp('edit');
                        } catch (error) {
                            logErrorToConsole(error);
                         }
                    }}
                    content={
                        'edit'
                    }
                    width={'100%'}
                    marginB={'25px'}
                    position={'static'}
                    height={'auto'}
                    title={
                        t('orders.deliveryCheck.editTitle')
                    }
                    fontWeight={'800'}
                />
            )}
            {!isAllowed && statusCode === '13203' && isFutureDatedOrder && (
                <MessageTemplate
                    isDeliveryCheck={true}
                    onClose={() => {
                        try {
                        handleCloseDeliveryCheckPopUp();
                        } catch (error) {
                           logErrorToConsole(error);
                        }
                    }}
                    content={
                        'noUsageToReport'
                    }
                    width={'100%'}
                    marginB={'25px'}
                    position={'static'}
                    height={'auto'}
                    title={
                        t('orders.deliveryCheck.noUsageTitle')
                    }
                    fontWeight={'800'}
                />

            )}
            {isAllowed && statusCode === '13201' && isFutureDatedOrder && (
                <MessageTemplate
                    isDeliveryCheck={false}
                    onClose={() => {
                        try {
                        handleCloseDeliveryCheckPopUp();
                        } catch (error) {
                           logErrorToConsole(error);
                        }
                    }}
                    content={
                        t('orders.deliveryCheck.confirmOrderCancellation')
                    }
                    width={'100%'}
                    marginB={'25px'}
                    position={'static'}
                    height={'auto'}
                    title={
                        t('orders.deliveryCheck.cancelTitle')
                    }
                    fontWeight={'800'}
                    myCaseRef={myCaseRef ? myCaseRef : tableRowData?.myCaseRef}
                    handleNoReportUsageCancellation={() => handleNoReportUsageCancellation(myCaseRef ? myCaseRef : tableRowData?.myCaseRef)}
                />

            )}

        </OrdersListViewContainer>
    );
};

export default OrdersListTableView;

const MdiOptions = styled.span`
    width: 18px;
    height: 18px;
    margin-left: 4px;
    margin-top: 5px;
    background-image: url(${({ imageSrc }) => imageSrc && imageSrc});
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    margin-right: 5px;
`;

const OrdersActionStatusLine = styled.span`
    position: absolute;
    top: 8px;
    bottom:0px;
    left: 0;
    width: 3px;
    pointer-events: none;
`;
